module.exports = __webpack_public_path__ + "static/img/new_header1.78dddc5a.png";